export const API = {
	AUTHENTICATE: {
		USER_REGISTRATION: '/ajax/authenticate/userRegistration',
	},
	USER_REGISTRITAION: '/ajax/userRegistration',
};
